import { QueueKey } from 'flow/types/EntityKeys';
import {
    selectKeysWaitingQueueItems,
    selectQueueHasOmniSupport,
} from 'flow/selectors/queue-selectors';
import { useAppSelector } from 'flow/hooks/useRedux';
import useAppContext from 'flow/hooks/useAppContext';
import EmptyState from 'flow/pages/messages/EmptyState';

interface Props {
    queueKey: QueueKey;
}

const EmptyStateQueueItemsWaiting = ({ queueKey }: Props) => {
    const { i18next } = useAppContext();

    const waitingKeys = useAppSelector((state) =>
        selectKeysWaitingQueueItems(state, queueKey),
    );

    const queueHasOmniSupport = useAppSelector((state) =>
        selectQueueHasOmniSupport(state, queueKey),
    );

    if (waitingKeys?.size) return null;

    return (
        <EmptyState
            className="bg-gray-100!"
            message={
                queueHasOmniSupport
                    ? i18next.t('Queue.Omni.Section.Empty')
                    : i18next.t('calls.incoming.none')
            }
        />
    );
};

export default EmptyStateQueueItemsWaiting;
